import React from "react";
import {
  //Redirect,
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
//import Login from "./components/Login/login";
import Main from "./components/skeleton/main";
import ProtectedRoute from "./components/ProtectedRoute/protected-route";
import { Helmet } from "react-helmet";
import axios from "axios";
import ForgotPassword from "./components/Login/forgotpassword";
import ForgotPasswordConfirm from "./components/Login/forgotpasswordconfirm";
import LoginMain from "./components/Login/loginMain";
/* import "./reset.css"; */
import "./App.scss";
import RegisterMain from "./components/Game/register";
import InstitutionRegister from "./components/Game/Institution/institutionRegister";
import CustomRegister from "./components/Game/Custom/customRegister";
import FreeRegister from "./components/Game/Free/freeRegister";
import LandingPage from "./components/Landing/landing";
import Leaderboard from "./components/Leaderboard/leaderboard";
const App = () => {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL + "/api";
  /* useEffect(() => {
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL + "/api";
  }, []); */

  return (
    <div style={{ height: "100%" }} className="main-background">
      <Helmet>
        <title>{process.env.REACT_APP_TITLE}</title>
      </Helmet>
      <Router>
        <Switch>
          <Route exact path="/login" component={LoginMain} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route
            exact
            path="/forgot-password-confirm/:token"
            component={ForgotPasswordConfirm}
          />
          <ProtectedRoute
            path="/tl"
            component={Main}
            rights={[1, 2, 3, 4, 5]}
          />
          <Route exact path="/institution" component={InstitutionRegister} />
          <Route exact path="/custom" component={CustomRegister} />
          <Route exact path="/free" component={FreeRegister} />
          <Route exact path="/register" component={RegisterMain} />
          <Route exact path="/leaderboard" component={Leaderboard} />
          <Route exact path="" component={LandingPage} />
          {/* MINDIG A VÉGÉN LEGYEN EZ A SOR!!!!!! */}
          {/* <Redirect from="**" to="/login" /> */}
        </Switch>
      </Router>
    </div>
  );
};

export default App;
